// Odluka tajmera isteka rezervacije. Istek TOKOM naplate NE sme da otpusti
// karte (race: tajmer bi pustio sedišta dok Payten naplaćuje) — čeka se ishod
// /finalize: uspeh vodi na potvrdu, neuspeh pušta karte na sledećem otkucaju.
export function shouldReleaseOnExpiry({ alreadyHandled, paymentProcessing }) {
    if (alreadyHandled) return false;
    if (paymentProcessing) return false;
    return true;
}
